function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "list");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "list",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Analytics-Copy",
  transform: "translate(25.000000, 25.000000) scale(1, -1) rotate(90.000000) translate(-25.000000, -25.000000) translate(4.000000, 1.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Analytics",
  transform: "translate(21.000000, 24.000000) scale(-1, 1) rotate(-90.000000) translate(-21.000000, -24.000000) translate(-3.000000, 3.000000)"
}, React.createElement("path", {
  d: "M2.00140377,37.2 L29.1985962,37.2 C30.303941,37.2 31.2,38.096059 31.2,39.2014038 L31.2,39.9985962 C31.2,41.103941 30.303941,42 29.1985962,42 L2.00140377,42 C0.89605899,42 0,41.103941 0,39.9985962 L0,39.2014038 C0,38.096059 0.89605899,37.2 2.00140377,37.2 Z",
  id: "Rectangle",
  transform: "translate(15.600000, 39.600000) scale(-1, 1) translate(-15.600000, -39.600000) "
}), React.createElement("path", {
  d: "M2.00140377,25.2 L38.7985962,25.2 C39.903941,25.2 40.8,26.096059 40.8,27.2014038 L40.8,27.9985962 C40.8,29.103941 39.903941,30 38.7985962,30 L2.00140377,30 C0.89605899,30 0,29.103941 0,27.9985962 L0,27.2014038 C0,26.096059 0.89605899,25.2 2.00140377,25.2 Z",
  id: "Rectangle",
  transform: "translate(20.400000, 27.600000) scale(-1, 1) translate(-20.400000, -27.600000) "
}), React.createElement("path", {
  d: "M2.00140377,0 L45.9985962,0 C47.103941,0 48,0.89605899 48,2.00140377 L48,2.79859623 C48,3.90394101 47.103941,4.8 45.9985962,4.8 L2.00140377,4.8 C0.89605899,4.8 0,3.90394101 0,2.79859623 L0,2.00140377 C0,0.89605899 0.89605899,0 2.00140377,0 Z",
  id: "Rectangle-Copy-24",
  transform: "translate(24.000000, 2.400000) scale(-1, 1) translate(-24.000000, -2.400000) "
}), React.createElement("path", {
  d: "M2.00140377,12 L21.9985962,12 C23.103941,12 24,12.896059 24,14.0014038 L24,14.7985962 C24,15.903941 23.103941,16.8 21.9985962,16.8 L2.00140377,16.8 C0.89605899,16.8 0,15.903941 0,14.7985962 L0,14.0014038 C0,12.896059 0.89605899,12 2.00140377,12 Z",
  id: "Rectangle-Copy-23",
  transform: "translate(12.000000, 14.400000) scale(-1, 1) translate(-12.000000, -14.400000) "
}))));

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.cdced348.svg";
export { ForwardRef as ReactComponent };